import React, { useState, useContext, useEffect } from 'react';
import $ from 'jquery';
import { Row, Col, Button, Form, Spinner } from 'react-bootstrap';
import toast from 'react-hot-toast';

import PsContext from '../../../context';
import api from '../../../utils/api';

const AddSabai=(props)=>{
	
	const context = useContext(PsContext);
	
	const [loader, setLoader] = useState(false);
	const [validated, setValidated] = useState(false);
	
	const [pastorate, setPastorate] = useState([]);
	const [churches, setChurches] = useState([]);
	const [church, setChurch] = useState([]);
	
	const loadData=()=>{
		setLoader(true);
		api.get(`v1/pastorate/list?status=1&api=${context.state.api}`).then(res=>{
			if(res['data'].errorcode=='200'){
				setPastorate(res['data'].data);
			}
			setLoader(false);
		});
		
		api.get(`v1/church/list?status=1&api=${context.state.api}`).then(res=>{
			if(res['data'].errorcode=='200'){
				setChurches(res['data'].data);
			}
			setLoader(false);
		});
	};
	
	useEffect(()=>{
		
		loadData();
	},[]);
	
	const handleSubmit=(e)=>{
		e.preventDefault();
		const form = e.currentTarget;
		if (form.checkValidity() === false) {
		  e.stopPropagation();
		  setValidated(true);
		  return;
		}
		
		setLoader(true);
		api.post('v1/sabai/create', $("#frm_add_sabai").serialize()).then(res=>{
			if(res['data'].errorcode=='200'){
				document.getElementById("frm_add_sabai").reset();
				toast.success(res['data'].content || 'Success');
				setLoader(false);
				
				if(props.afterFinish)
					props.afterFinish();
			}
			else{
				toast.error(res['data'].content || 'Error');
				setLoader(false);
			}
		});
	}
	
	const pastorateChage=(e)=>{
		var c = churches.filter( item => item.pastorate_id==e.target.value);
		setChurch(c);
	}
	
	
	return(
	<>
		<Form 
			noValidate 
			validated={validated} 
			id="frm_add_sabai"
			onSubmit={handleSubmit}
		>
			<div className="cb__modal__body" >
				<input type="hidden" name="api" value={context.state.api} />
				<Row>
					<Col md={12} >
						<label>Select the Pastrorate <span className="text-danger">*</span> </label>
						<Form.Control
							as="select"
							size="md"
							name="pastorate_name"
							required
							autoFocus={true}
							onChange={ e => pastorateChage(e) }
								
						>
							<option value=""> Select </option>
							{pastorate && pastorate.length>0 && (pastorate.map((item,i)=> <option value={item.id} key={i}> {item.name} </option>))}
						</Form.Control>
					</Col>	
				</Row>
				
				<Row className='mt-1' >
					<Col md={12} >
						<label>Select the Church <span className="text-danger">*</span> </label>
						<Form.Control
							as="select"
							size="md"
							name="church_name"
							required
						>
							<option value=""> Select </option>
							{church && church.length>0 && (church.map((item,i)=> <option value={item.id} key={i}> {item.name} </option>))}
						</Form.Control>
					</Col>	
				</Row>
				
				<Row className='mt-1' >
					<Col md={12} >
						<label>Name of the Sabai <span className="text-danger">*</span> </label>
						<Form.Control
							type="text"
							size="md"
							name="sabai_name"							
							required
						/>
					</Col>	
				</Row>
				
				
				<Row className='mt-1' >
					<Col md={6} >
						<label>Mobile <span className="text-danger"></span> </label>
						<Form.Control
							type="text"
							size="md"
							name="mobile"							
						/>
					</Col>	
					<Col md={6} >
						<label>Pastor Name <span className="text-danger"></span> </label>
						<Form.Control
							type="text"
							size="md"
							name="pastor_name"							
						/>
					</Col>	
				</Row>
				
				<Row className="mt-1" >
					<Col md={12} >
						<label>Church Address <span className="text-danger"></span> </label>
						<Form.Control
							as="textarea"
							rows="4"
							name="address"
						/>
					</Col>	
				</Row>
				
				<Row className="mt-3" >
					<Col md={3} >
						<label>Status <span className="text-danger">*</span> </label>
						<Form.Control
							as="select"
							name="status"
							required
						>
							<option value="1" > Active </option>
							<option value="0" > In-Active </option>
						</Form.Control>
					</Col>	
				</Row>
				
			</div>
			<div className="cb__modal__footer" >
				<Row>
					<Col md={12} >
						<div className="text-right" >
							<Button
								type="submit"
								size="sm"
								variant="primary"
								disabled={loader}
							>
							{loader ? <>
								<Spinner animation="border" size="sm" /> <span className="ps-2 border-left">WAIT..</span>
							</> : <>
								<i className="icofont-check pe-2 border-right" ></i> SAVE
							</>}
							</Button>
						</div>
					</Col>
				</Row>
			</div>
		</Form>
	</>
	);
};

export default AddSabai;